import { gql, GqlFragment } from 'src/utils/gql/query';
import { materialsBasicFragment } from 'src/modules/materials/graphql/materials-basic.fragment';
import { Materials, Materials_Filter } from 'src/graphql/schema.graphql';

export const materialsBasicGqlQuery: GqlFragment<
  {
    materials: Materials[];
  },
  {
    filters: Materials_Filter;
    sort: string[];
    limit: number;
  }
> = gql`
  ${materialsBasicFragment}
  query MaterialsBasicQuery(
    $filters: materials_filter
    $sort: [String]
    $limit: Int
  ) {
    materials(filter: $filters, sort: $sort, limit: $limit) {
      ...materialsBasic
    }
  }
`;
